/* ============================================
   RELICS THEME — Main JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── NAV SCROLL BEHAVIOR ──
  const nav = document.querySelector('.site-nav');
  if (nav && !nav.classList.contains('site-nav--solid')) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // ── HAMBURGER MENU ──
  const hamburger = document.getElementById('hamburger');
  const menuPanel = document.getElementById('menuPanel');
  const menuOverlay = document.getElementById('menuOverlay');

  if (hamburger && menuPanel && menuOverlay) {
    hamburger.addEventListener('click', toggleMenu);
    menuOverlay.addEventListener('click', closeMenu);
  }

  function toggleMenu() {
    const open = menuPanel.classList.toggle('open');
    menuOverlay.classList.toggle('open', open);
    hamburger.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function closeMenu() {
    menuPanel.classList.remove('open');
    menuOverlay.classList.remove('open');
    hamburger.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Close menu on nav link click
  document.querySelectorAll('.menu-nav a, .menu-utility a').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  // ── SCROLL REVEAL ──
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length > 0) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { observer.observe(el); });
  }

  // ── PRODUCT CAROUSEL ──
  const carouselInner = document.getElementById('carouselInner');
  const thumbEls = document.querySelectorAll('.carousel-thumb');
  let currentSlide = 0;
  const totalSlides = thumbEls.length;

  if (carouselInner && totalSlides > 0) {
    window.goToSlide = function (n) {
      currentSlide = Math.max(0, Math.min(n, totalSlides - 1));
      carouselInner.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      thumbEls.forEach(function (t, i) {
        t.classList.toggle('active', i === currentSlide);
      });
    };

    window.carouselNext = function () {
      goToSlide(currentSlide < totalSlides - 1 ? currentSlide + 1 : 0);
    };

    window.carouselPrev = function () {
      goToSlide(currentSlide > 0 ? currentSlide - 1 : totalSlides - 1);
    };

    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') carouselNext();
      if (e.key === 'ArrowLeft') carouselPrev();
    });
  }

});
